export type ProductTypeKey =
  | "Course"
  | "Accommodation"
  | "Transfer"
  | "AddOn"
  | "Package";

export const PRODUCT_TYPE_NAME_TO_ID: Record<ProductTypeKey, number> = {
  Course: 1,
  Accommodation: 2,
  AddOn: 3,
  Transfer: 4,
  Package: 5,
};

export const PRODUCT_TYPE_ID_TO_NAME: Record<number, ProductTypeKey> = {
  1: "Course",
  2: "Accommodation",
  3: "AddOn",
  4: "Transfer",
  5: "Package",
};

export const PRODUCT_TYPE_LABELS: Record<ProductTypeKey, string> = {
  Course: "Courses",
  Accommodation: "Accommodation",
  Transfer: "Transfers",
  AddOn: "Add Ons",
  Package: "Packages",
};

export const productTypeNameFromId = (id: number): string => {
  switch (id) {
    case 1:
      return "Course";
    case 2:
      return "Accommodation";
    case 3:
      return "AddOn";
    case 4:
      return "Transfer";
    case 5:
      return "Package";
    case 6:
      return "Fee";
    default:
      return `Type ${id}`;
  }
};

export const productTypeIdFromName = (
  name: string
): number | undefined => {
  return PRODUCT_TYPE_NAME_TO_ID[name as ProductTypeKey];
};